import Navbar from "@/components/kenjosset/Navbar"
import Flash from "@/components/kenjosset/Flash"
import Footer from "@/components/kenjosset/Footer"
import ContactForm from "@/components/kenjosset/ContactForm"
import type { KenjossetChrome } from "@/components/kenjosset/types"

interface Props {
  chrome: KenjossetChrome
}

// Faithful React port of kenjosset/contact.html.slim. `sm:md-0` is not a real
// Tailwind class; it is carried over verbatim from the Slim view.
export default function Contact({ chrome }: Props) {
  return (
    <div className="bg-light min-h-screen">
      <Navbar chrome={chrome} />

      <div className="min-h-[calc(100vh-500px)] h-full">
        <div className="max-w-5xl mx-auto flex w-full pt-12">
          <div className="w-full px-12 sm:md-0">
            <div className="text-2xl font-bold mb-6">Une idée de projet ? Contactez-moi !</div>

            <ContactForm submitClassName="btn btn-primary" />
          </div>
        </div>
      </div>

      <Footer chrome={chrome} />
      <Flash />
    </div>
  )
}
